/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Save_HintInputs */

const en_wc_on_save_hint = /** @type {(inputs: Wc_On_Save_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save your work with Ctrl/Cmd + S. Choose a file location when prompted, or check your browser downloads. Canceling the save dialog does not save the document.`)
};

/**
* | output |
* | --- |
* | "Save your work with Ctrl/Cmd + S. Choose a file location when prompted, or check your browser downloads. Canceling the save dialog does not save the document." |
*
* @param {Wc_On_Save_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_save_hint = /** @type {((inputs?: Wc_On_Save_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Save_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_save_hint(inputs)
});
export { wc_on_save_hint as "wc.on.save_hint" }